import { PRODUCTS_SERVICE } from "@/services/products.service.js";


const state = { listOutput: {}, processTask: false };

const actions = {
    getList({ dispatch, commit }, inputGetProducts) {
        dispatch('alert/clear', null, { root: true });
        commit('listRequest');
        
        PRODUCTS_SERVICE.list(inputGetProducts)
            .then(
                output => {
                    commit('listSuccess', output);
                },
                error => {
                    commit('listFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    editProduct({ dispatch, commit }, product) {
        dispatch('alert/clear', null, { root: true });
        commit('editRequest');
        PRODUCTS_SERVICE.edit(product)
            .then(
                output => {
                    commit('editSuccess', output);
                },
                error => {
                    commit('editFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    addProduct({ dispatch, commit }, product) {
        dispatch('alert/clear', null, { root: true });
        commit('addRequest');
        
        PRODUCTS_SERVICE.add(product)
            .then(
                output => {
                    commit('addSuccess', output);
                },
                error => {
                    commit('addFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    updateStatus({ dispatch, commit }, inputStatus) {
        dispatch('alert/clear', null, { root: true });
        commit('updateStatusRequest');

        PRODUCTS_SERVICE.updateStatus(inputStatus)
            .then(
                output => {
                    commit('updateStatusSuccess', output);
                },
                error => {
                    commit('updateStatusFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    /* List */
    listRequest(state) {
        //
    },
    listSuccess(state, output) {
        state.listOutput = output;
    },
    listFailure(state) {
        state.listOutput = [];
    },
    /* Add */
    addRequest(state) {
        state.processTask = null;
    },
    addSuccess(state) {
        state.processTask = true;
    },
    addFailure(state) {
        state.processTask = false;

    },
    /* Edit */
    editRequest(state) {
        state.processTask = null;
    },
    editSuccess(state) {
        state.processTask = true;
    },
    editFailure(state) {
        state.processTask = false;
    },
    /* Update status */
    updateStatusRequest(state) {
        state.processTask = null;
    },
    updateStatusSuccess(state) {
        state.processTask = true;
    },
    updateStatusFailure(state) {
        state.processTask = false;
    },
};


export const products = {
    namespaced: true,
    state,
    actions,
    mutations
};